<ng-container *ngIf="this.hasPermission">
    <button type="button" [ngStyle]="UIUtilityService.getVoiceCommandButtonStyle()" class="btn btn-white d-flex flex-row justify-content-center align-items-center px-2 py-1 ms-2"
        (click)="onButtonClick()">
          <mat-icon svgIcon="farMicrophone" class="mx-auto my-1 icon-center white-icon" [ngStyle]="UIUtilityService.getBankTextColor()"></mat-icon>
    </button>
</ng-container>